export class QueueFinished {
    constructor({ transfer }) {
        this.name = 'queueFinished';
        this.transfer = { ...transfer };
    }
    get data() {
        return {
            transfer: this.transfer,
        };
    }
}
